import { FormEventHandler, type PropsWithChildren } from 'react'

type FormProps = {
    className?: string
    onSubmit?: FormEventHandler<HTMLFormElement>
    autoComplete?: string
} & PropsWithChildren

export const Form: React.FC<FormProps> = (props) => {
    const {
        className = '',
        autoComplete,
        children,
        onSubmit = () => undefined,
    } = props
    return (
        <form
            className={`space-y-8 ${className}`}
            onSubmit={(e) => {
                e.preventDefault()
                onSubmit(e)
            }}
            autoComplete={autoComplete}
            role="form"
        >
            {children}
        </form>
    )
}
